"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSettingsButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Button_1 = require("../../../Button");
const Icon_1 = require("../../../Icon");
const TemplateSettingsButton = (props) => {
    const { click, canClick, isTemplateSelected } = props;
    return (react_1.default.createElement("div", { className: `${__1.className}__settings` },
        isTemplateSelected && (react_1.default.createElement(Button_1.Button, { icon: 'settings', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Settings', defaultMessage: 'Settings' }), modificators: 'light', onClick: click, disabled: !canClick })),
        !isTemplateSelected && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", null,
                react_1.default.createElement(Icon_1.Icon, { name: 'info' })),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:SettingsInfo', defaultMessage: 'Please select template to configure seatmap.' })))));
};
exports.TemplateSettingsButton = TemplateSettingsButton;
//# sourceMappingURL=TemplateSettingsButton.js.map